import React, { forwardRef, useState, useEffect, useRef } from "react";
// import "../../components/CommonStyle.css";
import CalendarImg from "../../Images/calendar.png";
import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import InputFieldLargeDisabled from "../StyledComp/InputFieldLargeDisabled";
import MemberServices from "../../services/MemberServices";
import AdminUserService from "../../services/adminUserServices";
import DateFieldLargeDisabled from "../StyledComp/DateFieldLargeDisabled";
import InputFieldSmallDisabled from "../StyledComp/InputFieldSmallDisabled";
import InputFieldExtraLargeDisabled from "../StyledComp/InputFieldExtraLargeDisabled";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import { useDispatch, useSelector } from "react-redux";
import { changeCurrentMemberMenu } from "../../store/screenSlice";
import { screenConfig } from "../../config/screenConfig";
import { Button, Label, PageLink } from "../StyledComp/StyledComp";
import { FormatUtils } from "../util/FormatUtils";
import "../../Styles/memberModal.css";
import {
  assignMemberPublishedAddress,
  editMemberPublishedAddress,
} from "../../store/editMemberapiSlice";
import { assignCurrentMember } from "../../store/currentMemberSlice";
import ReactModal from "react-modal";
import { RootState } from "../../store/store";
import { convertCompilerOptionsFromJson } from "typescript";
import DropdownIcon from "../../Images/dropdownIcon";
import EmailIcon from "../../Images/MemberIconComp/EmailIcon";
import { useForm } from "react-hook-form";
import { DevTool } from "@hookform/devtools";
import { IAddress } from "../../store/memberInterfaceStruct";
import AlertWithModal from "../utilityComponents/AlertWithModal";

interface MemberCode {
  [key: string]: any;
}
interface Memberype {
  [key: string]: any;
}
interface AddressData {
  [key: string]: any;
}
interface IProps {
  MemberCode: MemberCode[];
  MemberType: Memberype[];
  AddressData: AddressData;
}

interface IConfiguration {
  [key: string]: any;
}

type FormValues = {
  FirmName: string;
  Address1: string;
  Address2: string;
  City: string;
  County: string;
  State: string;
  Zipcode: string;
  PhoneNumber: string;
  CellPhoneNumber: string;
  FaxNumber: string;
  Email: string;
  FirmAdminName: string;
  FirmAdminEmailId: string;
  FirmAdminPhoneNumber: string;
};

const MDPublishedAddress: React.FC = () => {
  const currentMember = useAppSelector((state) => state.currentMember);
  console.log(currentMember);
  const dispatch = useDispatch();

  let publishedAddress = currentMember.PublishedAddress;

  console.log("publishedAddress", publishedAddress);

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");

  let pubAddress: string[] = [];
  publishedAddress?.Address1 &&
    pubAddress.push(`${publishedAddress?.Address1}, `);
  publishedAddress?.Address2 &&
    pubAddress.push(`${publishedAddress?.Address2}, `);
  publishedAddress?.City && pubAddress.push(`${publishedAddress?.City}, `);
  // publishedAddress?.County && pubAddress.push(`${publishedAddress?.County}, `);
  publishedAddress?.State && pubAddress.push(`${publishedAddress?.State} `);
  publishedAddress?.Zipcode && pubAddress.push(publishedAddress?.Zipcode);


  const form = useForm<FormValues>();
  const { register, control, handleSubmit, formState, setValue } = form;
  const { errors, touchedFields, dirtyFields } = formState;

  let [FirmName, setFirmName] = useState<string>(
    publishedAddress?.FirmName != undefined ? publishedAddress?.FirmName : ""
  );
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);
  const [Address1, setAddress1] = useState(publishedAddress?.Address1);
  const [Address2, setAddress2] = useState(publishedAddress?.Address2);
  const [City, setCity] = useState(publishedAddress?.City);
  const [County, setCounty] = useState(publishedAddress?.County);
  const [State, setState] = useState(publishedAddress?.State);
  const [Zipcode, setZipcode] = useState(publishedAddress?.Zipcode);
  const [PhoneNumber, setPhoneNumber] = useState(
    FormatUtils.formatPhoneNumberWithCCAndExtension(publishedAddress?.PhoneNumber)
  );
  const [CellPhoneNumber, setCellPhoneNumber] = useState(
    FormatUtils.formatPhoneNumberWithCCAndExtension(publishedAddress?.CellPhoneNumber)
  );
  const [FaxNumber, setFaxNumber] = useState(
    FormatUtils.formatFaxNumber(publishedAddress?.FaxNumber)
  );
  const [Email, setEmail] = useState(publishedAddress?.Email);
  const [FirmAdminEmailId, setFirmAdminEmailId] = useState(
    publishedAddress?.FirmAdminEmailId
  );
  const [FirmAdminPhoneNumber, setFirmAdminPhoneNumber] = useState(
    FormatUtils.formatPhoneNumberWithCCAndExtension(publishedAddress?.FirmAdminPhoneNumber)
  );
  const [FirmAdminName, setFirmAdminName] = useState(
    publishedAddress?.FirmAdminName
  );

  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );

  const resetEditState = () => {
    setFirmName(publishedAddress!.FirmName);
    setAddress1(publishedAddress!.Address1);
    setAddress2(publishedAddress!.Address2);
    setCity(publishedAddress!.City);
    setCounty(publishedAddress!.County);
    setState(publishedAddress!.State);
    setZipcode(publishedAddress!.Zipcode);
    setPhoneNumber(FormatUtils.formatPhoneNumberWithCCAndExtension(publishedAddress!.PhoneNumber));
    setCellPhoneNumber(FormatUtils.formatPhoneNumberWithCCAndExtension(publishedAddress!.CellPhoneNumber));
    setFaxNumber(FormatUtils.formatFaxNumber(publishedAddress!.FaxNumber));
    setEmail(publishedAddress!.Email);
    setFirmAdminEmailId(publishedAddress!.FirmAdminEmailId);
    setFirmAdminPhoneNumber(
      FormatUtils.formatPhoneNumberWithCCAndExtension(publishedAddress!.FirmAdminPhoneNumber)
    );
    setFirmAdminName(publishedAddress!.FirmAdminName);
  };

  const [divDisplayState, setdivDisplayState] = useState("none");
  // const [disableInputField, setdisableInputField] = useState<boolean>(true);
  const firmListdivRef = useRef<HTMLDivElement>(null);
  let [inputFirmName, setinputFirmName] = useState<any[]>([]);

  const [memberList, setMmberList] = useState<any[]>([]);
  let memberListNew: any[] = [];

  const [modalOpen, setModalOpen] = useState(false);

  function openMemberEditPublishedAddressScreen() {
    dispatch(
      changeCurrentMemberMenu(screenConfig.memberEditPublishedAddressScreen)
    );
  }

  const editMemberPublishedAddressBody = useSelector(
    (state: RootState) => state.editMemberapiSlice.PublishedAddress
  );

  const [configurationList, setConfigurationLists] = useState<IConfiguration>(
    {}
  );

  const [isHandleOutsideClickTriggered, setIsHandleOutsideClickTriggered] =
    useState<boolean>(false);
  const [firmNameError, setFirmNameError] = useState<string>("");
  const [isSaveDisabled, setIsSaveDisabled] = useState<boolean>(false);

  const setFirmAdminDetails = (firmlist: IAddress) => {
    console.log("firmlist:", firmlist);
    setFirmAdminName(firmlist?.FirmAdminName);
    setFirmAdminEmailId(firmlist?.FirmAdminEmailId);
    setFirmAdminPhoneNumber(firmlist?.FirmAdminPhoneNumber);
  };

  useEffect(() => {
    dispatch(
      editMemberPublishedAddress({
        key: "MemberId",
        value: currentMember.Id as unknown as string,
      })
    );
    dispatch(
      editMemberPublishedAddress({ key: "AddressType", value: "Published" })
    );
    const getConfigurationLists = async () => {
      console.log("getAdminList called");
      const response = await MemberServices.getConfigurationList();
      console.log("response...", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success");
        // console.log("response1...", response.data.data);
        setConfigurationLists(response.data.data);
      } else {
      }
    };

    const getFirmDetailList = async () => {
      console.log("getFirmDetailList called");
      const response = await MemberServices.getFirmDetailList();
      console.log("FirmDetailList response...", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success");
        setinputFirmName(response.data.data);

        // set firm admin details
        const selectedFirm = response.data.data.find(
          (firm: IAddress) => firm.Id == publishedAddress?.FirmId
        );

        selectedFirm && setFirmAdminDetails(selectedFirm);
        // dispatch(updateMemberList(response.data.data));
      } else {
      }
    };

    if (isInitialLoad) {
      setIsInitialLoad(false);
      getFirmDetailList();

      getConfigurationLists();
      dispatch(assignMemberPublishedAddress(currentMember.PublishedAddress!));
    }

    setValue(
      "FirmName",
      publishedAddress?.FirmName ? publishedAddress.FirmName : "",
      {
        shouldDirty: true,
      }
    );

    setValue(
      "Address1",
      publishedAddress?.Address1 ? publishedAddress.Address1 : "",
      {
        shouldDirty: true,
      }
    );
    setValue("State", publishedAddress?.State ? publishedAddress.State : "", {
      shouldDirty: true,
    });
    setValue(
      "Zipcode",
      publishedAddress?.Zipcode ? publishedAddress.Zipcode : "",
      {
        shouldDirty: true,
      }
    );
    setValue(
      "PhoneNumber",
      publishedAddress?.PhoneNumber
        ? FormatUtils.formatPhoneNumberWithCCAndExtension(publishedAddress.PhoneNumber)
        : "-",
      {
        shouldDirty: true,
      }
    );
    setValue(
      "CellPhoneNumber",
      publishedAddress?.CellPhoneNumber
        ? FormatUtils.formatPhoneNumberWithCCAndExtension(publishedAddress.CellPhoneNumber)
        : "-",
      {
        shouldDirty: true,
      }
    );
    setValue("Email", publishedAddress?.Email ? publishedAddress.Email : "-", {
      shouldDirty: true,
    });
  }, []);

  useEffect(() => {
    //Doing this to trigger validation when selecting firm
    console.log("FirmName USEEffect:", isHandleOutsideClickTriggered);
    setValue("FirmName", FirmName ? FirmName : "", {
      shouldDirty: true,
    });

    setValue("Address1", Address1 ? Address1 : "-", {
      shouldDirty: true,
    });
    setValue("Address2", Address2 ? Address2 : "-", {
      shouldDirty: true,
    });
    setValue("City", City ? City : "-", {
      shouldDirty: true,
    });
    setValue("State", State ? State : "-", {
      shouldDirty: true,
    });
    setValue("County", County ? County : "-", {
      shouldDirty: true,
    });
    setValue("Zipcode", Zipcode ? Zipcode : "-", {
      shouldDirty: true,
    });
  }, [FirmName]);

  useEffect(() => {
    console.log(
      "USEEffect called isHandleOutsideClickTriggered:",
      isHandleOutsideClickTriggered
    );
    isHandleOutsideClickTriggered && handleOutsideClick();
  }, [isHandleOutsideClickTriggered]);

  useEffect(() => {
    console.log("USEEffect divDisplayState", isHandleOutsideClickTriggered);

    if (divDisplayState === "block") {
      console.log("EVENT ADDED");
      document.addEventListener("mousedown", updateIsHandleOutsideClickEnabled);
    } else if (divDisplayState === "none") {
      console.log("EVENT REMOVED");
      document.removeEventListener(
        "mousedown",
        updateIsHandleOutsideClickEnabled
      );
    }

    // Cleanup to ensure event is removed on unmount or when condition changes
    return () => {
      document.removeEventListener(
        "mousedown",
        updateIsHandleOutsideClickEnabled
      );
    };
  }, [divDisplayState]);

  const updateIsHandleOutsideClickEnabled = (event: MouseEvent) => {
    console.log(
      "updateIsHandleOutsideClickEnabled-start",
      isHandleOutsideClickTriggered
    );
    if (
      firmListdivRef.current &&
      !firmListdivRef.current.contains(event.target as Node)
    ) {
      setIsHandleOutsideClickTriggered(true);
    }
    console.log(
      "updateIsHandleOutsideClickEnabled-end",
      isHandleOutsideClickTriggered
    );
  };

  const validateFirmName = () => {
    if (!FirmName || FirmName.trim() === "") {
      setFirmNameError("");
      setIsSaveDisabled(false);
      return;
    }

    const isFirmNameExists = inputFirmName.find(
      (firmListItem) => firmListItem.FirmName === FirmName
    );

    if (!isFirmNameExists) {
      setFirmNameError("That firm will be created.");
      setIsSaveDisabled(false);
    } else {
      setFirmNameError("");
      setIsSaveDisabled(false);
    }
  };

  const handleOutsideClick = () => {
    // console.log(firmListdivRef);

    console.log("handleOutsideClick-start:", isHandleOutsideClickTriggered);
    inputFirmName.map((firmListItem: any) => {
      if (firmListItem.FirmName === FirmName) {
        console.log(firmListItem, "-", FirmName);
        console.log("firmItem.FirmName === FirmName");
        handleFirmNameClick(firmListItem);
      }
    });
    setdivDisplayState("none");
    console.log("handleOutsideClicked");
    document.removeEventListener(
      "mousedown",
      updateIsHandleOutsideClickEnabled
    );
    console.log();
    setIsHandleOutsideClickTriggered(false);

    const isFirmNameExists = inputFirmName.find(
      (firmListItem) => firmListItem.FirmName === FirmName
    );

    if (isFirmNameExists === undefined) {
      console.log("isFirmNameExists:", isFirmNameExists);
      console.log("isFirmNameExists-FirmName:", FirmName);
      // Don't clear the firm name - keep the user's input
      // The firm will be auto-created on save
    } else {
      console.log("FIRM NAME EXIST");
    }
    console.log("handleOutsideClick-end:", isHandleOutsideClickTriggered);
  };

  const States = configurationList.StateList;

  const emptyFunction = (event: React.ChangeEvent<HTMLInputElement>): void => {
    //empty function
  };

  const updateInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    console.log("event name:", event.target.name);
    console.log("event Value:", event.target.value);
    dispatch(
      editMemberPublishedAddress({
        key: event.target.name,
        value: event.target.value,
      })
    );
    switch (event.target.name) {
      case "Address1":
        setAddress1(event.target.value);
        break;
      case "Address2":
        setAddress2(event.target.value);
        break;
      case "Zipcode":
        setZipcode(event.target.value);
        break;
      case "City":
        setCity(event.target.value);
        break;
      case "County":
        setCounty(event.target.value);
        break;
      case "PhoneNumber":
        setPhoneNumber(FormatUtils.formatPhoneNumberWithCCAndExtension(event.target.value));
        break;
      case "CellPhoneNumber":
        setCellPhoneNumber(FormatUtils.formatPhoneNumberWithCCAndExtension(event.target.value));
        break;
      case "FaxNumber":
        setFaxNumber(FormatUtils.formatFaxNumber(event.target.value));
        break;
      case "Email":
        setEmail(event.target.value);
        break;
      case "FirmAdminEmailId":
        setFirmAdminEmailId(event.target.value);
        break;
      case "FirmAdminPhoneNumber":
        setFirmAdminPhoneNumber(FormatUtils.formatPhoneNumberWithCCAndExtension(event.target.value));
        break;
      case "FirmAdminName":
        setFirmAdminName(event.target.value);
        break;
      default:
        console.log("DEFAULT");
        break;
    }
  };

  const updateFirmInput = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    console.log("inputFirmName1:", event.target.value);
    dispatch(
      editMemberPublishedAddress({
        key: "FirmName",
        value: event.target.value,
      })
    );

    setValue("FirmName", event.target.value ? event.target.value : "", {
      shouldDirty: true,
    });

    setFirmName(event.target.value);
    setdivDisplayState("block");
    console.log("inputFirmName2:", FirmName);
  };

  const handleFirmFieldClick = (event: React.MouseEvent<HTMLElement>): void => {
    setdivDisplayState("block");
    console.log("inputFirmName0:", FirmName);
  };

  const onBlur = (event: any) => {
    console.log("TAB OUT");
    setdivDisplayState("none");
  };

  const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    console.log("handleSelect ", event.target.name, event.target.value);
    dispatch(
      editMemberPublishedAddress({
        key: "State",
        value: event.target.value,
      })
    );

    setValue("State", event.target.value ? event.target.value : "-", {
      shouldDirty: true,
    });

    setState(event.target.value);
  };

  const handleFirmNameClick = (newFirm: any) => {
    console.log("publishedAddress1:", newFirm);
    setdivDisplayState("none");
    setFirmName(newFirm.FirmName ? newFirm.FirmName : "");
    setAddress1(newFirm.Address1 ? newFirm.Address1 : "");
    setAddress2(newFirm.Address2 ? newFirm.Address2 : "");
    setCity(newFirm.City ? newFirm.City : "");
    setCounty(newFirm.County ? newFirm.County : "");
    setState(newFirm.State ? newFirm.State : "");
    setZipcode(newFirm.Zipcode ? newFirm.Zipcode : "");
    setFirmAdminEmailId(
      newFirm.FirmAdminEmailId ? newFirm.FirmAdminEmailId : ""
    );
    setFirmAdminPhoneNumber(
      newFirm.FirmAdminPhoneNumber
        ? FormatUtils.formatPhoneNumberWithCCAndExtension(newFirm.FirmAdminPhoneNumber)
        : ""
    );
    setFirmAdminName(newFirm.FirmAdminName ? newFirm.FirmAdminName : "");

    // Clear any validation errors since a valid firm was selected
    setFirmNameError("");
    setIsSaveDisabled(false);

    console.log("inputfirmname3:", FirmName);

    dispatch(editMemberPublishedAddress({ key: "Id", value: newFirm.Id }));
    dispatch(editMemberPublishedAddress({ key: "FirmId", value: newFirm.Id }));
    dispatch(
      editMemberPublishedAddress({ key: "FirmName", value: newFirm.FirmName })
    );
    dispatch(
      editMemberPublishedAddress({ key: "Address1", value: newFirm.Address1! })
    );
    dispatch(
      editMemberPublishedAddress({ key: "Address2", value: newFirm.Address2! })
    );
    dispatch(editMemberPublishedAddress({ key: "City", value: newFirm.City! }));
    dispatch(
      editMemberPublishedAddress({ key: "County", value: newFirm.County! })
    );
    dispatch(
      editMemberPublishedAddress({ key: "State", value: newFirm.State! })
    );
    dispatch(
      editMemberPublishedAddress({ key: "Zipcode", value: newFirm.Zipcode! })
    );
    // dispatch(
    //   editMemberPublishedAddress({
    //     key: "PhoneNumber",
    //     value: newFirm.PhoneNumber!,
    //   })
    // );
    // dispatch(
    //   editMemberPublishedAddress({
    //     key: "CellPhoneNumber",
    //     value: newFirm.CellPhoneNumber!,
    //   })
    // );
    // dispatch(
    //   editMemberPublishedAddress({ key: "Email", value: newFirm.Email! })
    // );
    dispatch(
      editMemberPublishedAddress({
        key: "FirmAdminEmailId",
        value: newFirm.FirmAdminEmailId!,
      })
    );
    dispatch(
      editMemberPublishedAddress({
        key: "FirmAdminPhoneNumber",
        value: newFirm.FirmAdminPhoneNumber!,
      })
    );
    dispatch(
      editMemberPublishedAddress({
        key: "FirmAdminName",
        value: newFirm.FirmAdminName!,
      })
    );
    setValue("FirmName", newFirm?.FirmName ? newFirm.FirmName : "-", {
      shouldDirty: true,
    });

    setValue("Address1", newFirm?.Address1 ? newFirm.Address1 : "-", {
      shouldDirty: true,
    });
    setValue("State", newFirm?.State ? newFirm.State : "-", {
      shouldDirty: true,
    });
    setValue("Zipcode", newFirm?.Zipcode ? newFirm.Zipcode : "-", {
      shouldDirty: true,
    });
    setValue(
      "FirmAdminEmailId",
      FormatUtils.formatPhoneNumberWithCCAndExtension(newFirm?.FirmAdminEmailId)
        ? newFirm.FirmAdminEmailId
        : "-",
      {
        shouldDirty: true,
      }
    );
    setValue(
      "FirmAdminPhoneNumber",
      FormatUtils.formatPhoneNumberWithCCAndExtension(newFirm?.FirmAdminPhoneNumber)
        ? newFirm.FirmAdminPhoneNumber
        : "-",
      {
        shouldDirty: true,
      }
    );
    setValue(
      "FirmAdminName",
      newFirm?.FirmAdminName ? newFirm.FirmAdminName : "-",
      {
        shouldDirty: true,
      }
    );
  };


  const copyFromPublishedAddress = () => {
    
    let newFirm = currentMember.PrimaryAddress!!;
    
    /* setValue(
      "PhoneNumber",
      newFirm?.PhoneNumber
        ? FormatUtils.formatPhoneNumberWithCCAndExtension(newFirm.PhoneNumber)
        : "-",
      {
        shouldDirty: true,
      }
    ); */

    /* setPhoneNumber(newFirm?.PhoneNumber
      ? FormatUtils.formatPhoneNumberWithCCAndExtension(newFirm.PhoneNumber)
      : "-"); */
      dispatch(
        editMemberPublishedAddress({
          key: "FirmName",
          value: (newFirm && newFirm.FirmName) ? newFirm?.FirmName : "",
        })
      );
  
      setValue("FirmName", (newFirm && newFirm.FirmName) ? newFirm.FirmName : "");
  
      setFirmName((newFirm && newFirm.FirmName) ? newFirm.FirmName : "");

          setAddress1((newFirm && newFirm.Address1) ? newFirm.Address1 : "");
  
          setAddress2(newFirm?.Address2 ? newFirm?.Address2 : "");

          setZipcode(newFirm?.Zipcode ? newFirm?.Zipcode : "");

          setState(newFirm?.State ? newFirm?.State : "")

          setCity(newFirm?.City ? newFirm?.City : "");

          setCounty(newFirm?.County ? newFirm?.County : "");

          setPhoneNumber(newFirm?.PhoneNumber ? FormatUtils.formatPhoneNumberWithCCAndExtension(newFirm?.PhoneNumber) : "");

          setCellPhoneNumber(newFirm?.CellPhoneNumber ? FormatUtils.formatPhoneNumberWithCCAndExtension(newFirm?.CellPhoneNumber) : "");

          setFaxNumber(newFirm?.FaxNumber ? FormatUtils.formatFaxNumber(newFirm?.FaxNumber) : "");

          setEmail(newFirm?.Email ? newFirm?.Email : "");

          setFirmAdminEmailId(newFirm?.FirmAdminEmailId ? newFirm?.FirmAdminEmailId : "");

          setFirmAdminPhoneNumber(newFirm?.FirmAdminPhoneNumber ? FormatUtils.formatPhoneNumberWithCCAndExtension(newFirm?.FirmAdminPhoneNumber) : "");

          setFirmAdminName(newFirm?.FirmAdminName ? newFirm?.FirmAdminName : "");


    dispatch(editMemberPublishedAddress({ key: "Id", value: newFirm?.Id ? newFirm.Id.toString() :""}));
    dispatch(editMemberPublishedAddress({ key: "FirmId", value: newFirm?.Id ? newFirm.Id.toString() : ""}));
    dispatch(
      editMemberPublishedAddress({ key: "FirmName", value: (newFirm && newFirm.FirmName) ? newFirm?.FirmName : "" })
    );
    dispatch(
      editMemberPublishedAddress({ key: "Address1", value: newFirm?.Address1 ? newFirm.Address1! : ""})
    );
    dispatch(
      editMemberPublishedAddress({ key: "Address2", value: newFirm?.Address2 ? newFirm.Address2! : ""})
    );
    dispatch(editMemberPublishedAddress({ key: "City", value: newFirm?.City ? newFirm.City! : ""}));
    dispatch(
      editMemberPublishedAddress({ key: "County", value: newFirm?.County ? newFirm.County! : ""})
    );
    dispatch(
      editMemberPublishedAddress({ key: "State", value: newFirm?.State ?newFirm.State! :""})
    );
    dispatch(
      editMemberPublishedAddress({ key: "Zipcode", value:  newFirm?.Zipcode ? newFirm.Zipcode! : ""})
    );

    dispatch(
      editMemberPublishedAddress({ key: "PhoneNumber", value: newFirm?.PhoneNumber ? newFirm.PhoneNumber! : ""})
    );

    dispatch(
      editMemberPublishedAddress({ key: "CellPhoneNumber", value: newFirm?.CellPhoneNumber ? newFirm.CellPhoneNumber! : ""})
    );

    dispatch(
      editMemberPublishedAddress({ key: "FaxNumber", value: FormatUtils.formatFaxNumber(newFirm?.FaxNumber ? newFirm.FaxNumber! : "")})
    );

    dispatch(
      editMemberPublishedAddress({ key: "Email", value: newFirm?.Email ? newFirm.Email! : ""})
    );
   
    dispatch(
      editMemberPublishedAddress({
        key: "FirmAdminEmailId",
        value: newFirm?.FirmAdminEmailId ? newFirm.FirmAdminEmailId! : "",
      })
    );
    dispatch(
      editMemberPublishedAddress({
        key: "FirmAdminPhoneNumber",
        value: newFirm?.FirmAdminPhoneNumber ? newFirm.FirmAdminPhoneNumber! : "",
      })
    );
    dispatch(
      editMemberPublishedAddress({
        key: "FirmAdminName",
        value: newFirm?.FirmAdminName? newFirm.FirmAdminName! : "",
      })
    );
    setValue("FirmName", newFirm?.FirmName ? newFirm.FirmName : "", {
      shouldDirty: true,
    });

    setValue("Address1", newFirm?.Address1 ? newFirm.Address1 : "-", {
      shouldDirty: true,
    });
    setValue("State", newFirm?.State ? newFirm.State : "-", {
      shouldDirty: true,
    });
    setValue("Zipcode", newFirm?.Zipcode ? newFirm.Zipcode : "-", {
      shouldDirty: true,
    });
    setValue(
      "FirmAdminEmailId",
      FormatUtils.formatPhoneNumberWithCCAndExtension(newFirm?.FirmAdminEmailId)
        ? newFirm.FirmAdminEmailId
        : "-",
      {
        shouldDirty: true,
      }
    );
    setValue(
      "FirmAdminPhoneNumber",
      FormatUtils.formatPhoneNumberWithCCAndExtension(newFirm?.FirmAdminPhoneNumber)
        ? newFirm.FirmAdminPhoneNumber
        : "-",
      {
        shouldDirty: true,
      }
    );
    setValue(
      "FirmAdminName",
      newFirm?.FirmAdminName ? newFirm.FirmAdminName : "",
      {
        shouldDirty: true,
      }
    );
   

  };

  const handleCancel = () => {
    setModalOpen(false);
    resetEditState();
  };

  const onSubmit = async () => {
    console.log(
      "editMemberPublishedAddressBody",
      editMemberPublishedAddressBody
    );

    // Check if firm exists
    const isFirmNameExists = inputFirmName.find(
      (firmListItem) => firmListItem.FirmName === FirmName
    );

    // If firm doesn't exist and user entered a firm name, create it first
    if (!isFirmNameExists && FirmName && FirmName.trim() !== "") {
      console.log("Creating new firm:", FirmName);

      const newFirmData = {
        FirmName: FirmName,
        Address1: Address1 || "No Current Address",
        Address2: Address2 || "",
        City: City || "No Current Address",
        State: State || "",
        Zipcode: Zipcode || "",
        County: County || "",
        FirmAdminEmailId: Email || currentMember.PublishedAddress?.Email || "",
        FirmAdminName: FirmAdminName || "",
        FirmAdminPhoneNumber: FirmAdminPhoneNumber || ""
      };

      try {
        const firmResponse = await AdminUserService.addFirm(newFirmData);
        console.log("Firm creation response:", firmResponse);

        if (firmResponse.data.data != null) {
          if (firmResponse.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Firm Creation Error");
            setAlertBody(firmResponse.data.errors[0].sqlMessage || firmResponse.data.errors[0]);
            return;
          }

          // Get the newly created firm's ID
          const firmIdToUse = firmResponse.data.data[0]?.Id || firmResponse.data.data.Id;
          console.log("New firm created with ID:", firmIdToUse);

          // Update the editMemberPublishedAddressBody with the new FirmId
          dispatch(editMemberPublishedAddress({ key: "Id", value: firmIdToUse }));
        } else {
          setShowAlertModal(true);
          setAlertTitle("Firm Creation Error");
          setAlertBody("Failed to create firm");
          return;
        }
      } catch (error) {
        console.error("Error creating firm:", error);
        setShowAlertModal(true);
        setAlertTitle("Firm Creation Error");
        setAlertBody("An error occurred while creating the firm");
        return;
      }
    }

    // Now proceed with updating the address
    const response = await MemberServices.editMemberAddress(
      editMemberPublishedAddressBody
    );

    console.log("response", response);

    // Check for errors first, regardless of data being null/not null
    if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage || response.data.errors[0]);
        return;
    }

    if (response.data.data != null) {
      alert("Address updated successfully");
      publishedAddress = response.data.data[0].PublishedAddress;
      dispatch(assignCurrentMember(response.data.data[0]));
      resetEditState();
    } else {
      console.log("error");
    }
    setModalOpen(false);
  };

  console.log("inputFirmName:", inputFirmName);

  const handleEdit = () => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("members.edit")
      )
    ) {
      alert("No Access");
      return;
    }
    setModalOpen(true);
  };

  return (
    <div className="section-box">
      <div className="horizontal-wrapper-spacebetween">
        <h1 className="page-heading">Published Address</h1>
        {/* <PageLink onClick={openMemberEditPublishedAddressScreen}>Edit</PageLink> */}
        <PageLink onClick={() => handleEdit()}>Edit</PageLink>
      </div>
      <form className="form-wrapper">
        <div className="input-field-div-wrapper">
          <Label>Firm Name</Label>
          <input
            className="input-field-div input-disabled"
            id="FirmName"
            name="FirmName"
            // value={publishedAddress!.FirmName}
            value={
              typeof FirmName != "undefined" || FirmName != null ? FirmName : ""
            }
            disabled={true}
          />
        </div>
        <div className="input-addressfield-div">
          <Label>Address</Label>
          <input
            className="input-field-div input-disabled"
            id="Address"
            name="Address"
            value={pubAddress.join("")}
            disabled={true}
          />
        </div>
        <div className="input-field-div-wrapper">
          <Label>County</Label>
          <input
            className="input-field-div input-disabled"
            id="County"
            name="County"
            value={
              typeof publishedAddress != "undefined" || publishedAddress != null
                ? publishedAddress?.County
                : ""
            }
            disabled={true}
          />
        </div>
        <div className="input-field-div-wrapper">
          <Label>Phone Number</Label>
          <input
            className="input-field-div input-disabled"
            id="PhoneNumber"
            name="PhoneNumber"
            value={publishedAddress?.PhoneNumber ? FormatUtils.formatPhoneNumberWithCCAndExtension(publishedAddress!.PhoneNumber) : ""}
            // value={
            //   typeof PhoneNumber != "undefined" || PhoneNumber != null
            //     ? PhoneNumber
            //     : ""
            // }
            disabled={true}
          />
        </div>

        <div className="input-field-div-wrapper">
          <Label>Cell Phone Number</Label>
          <input
            className="input-field-div input-disabled"
            id="CellPhoneNumber"
            name="CellPhoneNumber"
            value={publishedAddress?.CellPhoneNumber ? FormatUtils.formatPhoneNumberWithCCAndExtension(publishedAddress!.CellPhoneNumber) : ""}
            // value={
            //   typeof PhoneNumber != "undefined" || PhoneNumber != null
            //     ? PhoneNumber
            //     : ""
            // }
            disabled={true}
          />
        </div>

        <div className="input-field-div-wrapper">
          <Label>Fax Number</Label>
          <input
            className="input-field-div input-disabled"
            id="FaxNumber"
            name="FaxNumber"
            value={publishedAddress?.FaxNumber ? FormatUtils.formatFaxNumber(publishedAddress!.FaxNumber) : ""}
            // value={
            //   typeof FaxNumber != "undefined" || FaxNumber != null
            //     ? FaxNumber
            //     : ""
            // }
            disabled={true}
          />
        </div>
        <div className="input-field-div-wrapper">
          <Label>Email ID</Label>
          <input
            className="input-field-div input-disabled"
            id="EmailId"
            name="EmailId"
            value={publishedAddress!.Email}
            // value={typeof Email != "undefined" || Email != null ? Email : ""}
            disabled={true}
          />
        </div>

        <div className="input-field-div-wrapper">
          <Label>Firm Admin Name</Label>
          <input
            className="input-field-div input-disabled"
            id="FirmAdminName"
            name="FirmAdminName"
            value={FirmAdminName}
            // value={
            //   typeof FirmAdminName != "undefined" || FirmAdminName != null
            //     ? FirmAdminName
            //     : ""
            // }
            disabled={true}
          />
        </div>
        <div className="input-field-div-wrapper">
          <Label>Firm Admin Phone Number</Label>
          <input
            className="input-field-div input-disabled"
            id="FirmAdminPhoneNumber"
            name="FirmAdminPhoneNumber"
            value={FormatUtils.formatPhoneNumberWithCCAndExtension(FirmAdminPhoneNumber)}
            // value={
            //   typeof FirmAdminPhoneNumber != "undefined" ||
            //   FirmAdminPhoneNumber != null
            //     ? FirmAdminPhoneNumber
            //     : ""
            // }
            disabled={true}
          />
        </div>
        <div className="input-field-div-wrapper" style={{ width: "64%" }}>
          <Label>Firm Admin Email ID</Label>
          <input
            className="input-field-div input-disabled"
            id="FirmAdminEmailId"
            name="FirmAdminEmailId"
            value={FirmAdminEmailId}
            // value={
            //   typeof FirmAdminEmail != "undefined" || FirmAdminEmail != null
            //     ? FirmAdminEmail
            //     : ""
            // }
            disabled={true}
          />
        </div>
      </form>
      <ReactModal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Edit Published Address ({currentMember?.FirstName + " " + currentMember?.LastName})</h1>
          <button
            type="button"
            className="p-1 rounded bg-color c-primary-address"
            style={{ background: "#366287", color: "white" }}
            onClick={copyFromPublishedAddress}
          >
            Copy from Primary Address
          </button>

          <PageLink onClick={() => setModalOpen(false)}>Cancel</PageLink>
        </div>
        <form
          className="form-wrapper"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
        >
          <div
            className="input-field-div-wrapper"
            style={{
              position: "relative",
              borderColor: "var(--active-border-color)",
            }}
          >
            <Label>Firm Name</Label>
            <input
              className="input-field-div"
              id="FirmName"
              // {...register("FirmName", {
              //   required: "Firm Name is a required field",
              // })}
              // onBlur={onBlur}
              value={
                typeof FirmName != "undefined" || FirmName != null
                  ? FirmName
                  : ""
              }
              disabled={false}
              autoComplete="off"
              onChange={(e) => {
                updateFirmInput(e);
              }}
              onClick={handleFirmFieldClick}
              onBlur={validateFirmName}
            />
            <p className="form-error" style={{ color: firmNameError ? "red" : "" }}>
              {firmNameError || errors.FirmName?.message}
            </p>
            <div
              className="suggestion-dropdown"
              style={{ display: divDisplayState }}
              ref={firmListdivRef}
            >
              {inputFirmName
                ?.filter((item: any) => {
                  return item.FirmName != null;
                })
                .filter((item: any) => {
                  const serachItem = FirmName?.toLowerCase();
                  const itemFirmName = item.FirmName.toLowerCase();
                  return itemFirmName.startsWith(serachItem);
                })
                .map((item: any) => (
                  <div
                    className="suggested-item-row"
                    key={item.Id}
                    onClick={(event) => handleFirmNameClick(item)}
                  >
                    {item.FirmName}
                    {", "}
                    {item.City}
                  </div>
                ))}
            </div>
            <div className="dropdownIcon">
              <DropdownIcon />
            </div>
          </div>
          <span className="button-icon"></span>
          <div className="input-addressfield-div mt-2">
            <Label>Address 1</Label>
            <input
              className="input-field-div"
              id="Address1"
              name="Address1"
              // {...register("Address1", {
              //   required: "Address is a required field",
              // })}
              value={
                typeof Address1 != "undefined" || Address1 != null
                  ? Address1
                  : ""
              }
              onChange={(e) => {
                updateInput(e);
              }}
            />
            <p className="form-error">{errors.Address1?.message}</p>
          </div>
          <div className="input-addressfield-div">
            <Label>Address 2</Label>
            <input
              className="input-field-div"
              id="Address2"
              name="Address2"
              value={
                typeof Address2 != "undefined" || Address2 != null
                  ? Address2
                  : ""
              }
              onChange={(e) => {
                updateInput(e);
              }}
            />
          </div>

          <div className="input-field-div-wrapper m-0">
            <input
              className="input-field-div-small"
              id="City"
              name="City"
              placeholder=""
              autoComplete="off"
              value={typeof City != "undefined" || City != null ? City : ""}
              onChange={updateInput}
            />
            <label className="form-label" htmlFor="City">
              City
            </label>
          </div>

          <div className="input-field-div-wrapper">
            <Label>County</Label>
            <input
              className="input-field-div"
              id="County"
              name="County"
              value={
                typeof County != "undefined" || County != null ? County : ""
              }
              onChange={(e) => {
                updateInput(e);
              }}
            />
          </div>
          <div className="input-field-div-wrapper">
            <div className="selectfield-label">State</div>
            <select
              className="dropdown-control-large-insidetextfield"
              // {...register("State", {
              //   required: "State is a required field",
              // })}
              onChange={(e) => {
                handleSelect(e);
              }}
              value={typeof State != "undefined" || State != null ? State : ""}
            >
              <option value={""}>
                {typeof State != "undefined" || State != null ? State : ""}
              </option>
              {States?.map((State: any) => (
                <option key={State.Id} value={State.StateName}>
                  {State.StateName}
                </option>
              ))}
              ;
            </select>
            <p className="form-error">{errors.State?.message}</p>
          </div>
          <div className="input-field-div-wrapper">
            <Label>Zip Code</Label>
            <input
              className="input-field-div"
              id="Zipcode"
              name="Zipcode"
              // {...register("Zipcode", {
              //   required: "Zipcode is a required field",
              // })}
              value={
                typeof Zipcode != "undefined" || Zipcode != null ? Zipcode : ""
              }
              onChange={(e) => {
                updateInput(e);
              }}
            />
            <p className="form-error">{errors.Zipcode?.message}</p>
          </div>
          <div className="input-field-div-wrapper">
            <Label>Phone Number</Label>
            <input
              className="input-field-div"
              id="PhoneNumber"
              name="PhoneNumber"
              // {...register("PhoneNumber", {
              //   required: "PhoneNumber is a required field",
              //   // minLength: { value: 9, message: "Miminum 9 digit is required" },
              //   // maxLength: {
              //   //   value: 10,
              //   //   message: "Maximum 10 digit is allowed",
              //   // },
              // })}
              type="text"
              pattern="[0-9]*"
              value={
                typeof PhoneNumber != "undefined" || PhoneNumber != null
                  ? FormatUtils.formatPhoneNumberWithCCAndExtension(PhoneNumber)
                  : ""
              }
              onChange={(e) => {
                updateInput(e);
              }}
            />
            <p className="form-error">{errors.PhoneNumber?.message}</p>
          </div>

          <div className="input-field-div-wrapper">
            <Label>Cell Phone Number</Label>
            <input
              className="input-field-div"
              id="CellPhoneNumber"
              name="CellPhoneNumber"
              // {...register("CellPhoneNumber", {
              //   required: "PhoneNumber is a required field",
              //   // minLength: { value: 9, message: "Miminum 9 digit is required" },
              //   // maxLength: {
              //   //   value: 10,
              //   //   message: "Maximum 10 digit is allowed",
              //   // },
              // })}
              type="text"
              pattern="[0-9]*"
              value={
                typeof CellPhoneNumber != "undefined" || CellPhoneNumber != null
                  ? FormatUtils.formatPhoneNumberWithCCAndExtension(CellPhoneNumber)
                  : ""
              }
              onChange={(e) => {
                updateInput(e);
              }}
            />
            <p className="form-error">{errors.CellPhoneNumber?.message}</p>
          </div>

          <div className="input-field-div-wrapper">
            <Label>Fax Number</Label>
            <input
              className="input-field-div"
              id="FaxNumber"
              name="FaxNumber"
              type="text"
              
              value={
                typeof FaxNumber != "undefined" || FaxNumber != null
                  ? FormatUtils.formatFaxNumber(FaxNumber)
                  : ""
              }
              onChange={(e) => {
                updateInput(e);
              }}
            />
          </div>
          <div className="input-field-div-wrapper">
            <Label>Email ID</Label>
            <input
              className="input-field-div"
              id="Email"
              name="Email"
              // {...register("Email", {
              //   required: "Email is a required field",
              // })}
              value={typeof Email != "undefined" || Email != null ? Email : ""}
              type="email"
              onChange={(e) => {
                updateInput(e);
              }}
            />
            <p className="form-error">{errors.Email?.message}</p>
          </div>
          <div className="input-field-div-wrapper">
            <Label>Firm Admin Name</Label>
            <input
              className="input-field-div input-disabled"
              id="FirmAdminName"
              name="FirmAdminName"
              value={
                typeof FirmAdminName != "undefined" || FirmAdminName != null
                  ? FirmAdminName
                  : ""
              }
              // onChange={(e) => {
              //   updateInput(e);
              // }}
              disabled={true}
              onClick={() =>
                alert("Admin Name can be edited only in settings page.")
              }
            />
          </div>
          <div className="input-field-div-wrapper">
            <Label>Firm Admin Phone Number</Label>
            <input
              className="input-field-div input-disabled"
              id="FirmAdminPhoneNumber"
              name="FirmAdminPhoneNumber"
              type="text"
              pattern="[0-9]*"
              value={
                typeof FirmAdminPhoneNumber != "undefined" ||
                FirmAdminPhoneNumber != null
                  ? FormatUtils.formatPhoneNumberWithCCAndExtension(FirmAdminPhoneNumber)
                  : ""
              }
              // onChange={(e) => {
              //   updateInput(e);
              // }}
              disabled={true}
              onClick={() =>
                alert("Admin Phone Number can be edited only in settings page.")
              }
            />
          </div>
          <div className="input-field-div-wrapper">
            <Label>Firm Admin Email ID</Label>
            <input
              className="input-field-div input-disabled"
              id="FirmAdminEmailId"
              name="FirmAdminEmailId"
              value={
                typeof FirmAdminEmailId != "undefined" ||
                FirmAdminEmailId != null
                  ? FirmAdminEmailId
                  : ""
              }
              // onChange={(e) => {
              //   updateInput(e);
              // }}
              disabled={true}
              onClick={() =>
                alert("Admin EmailID can be edited only in settings page.")
              }
            />
          </div>
          <div className="horizontal-wrapper-centeralign">
            <div className="submit-button-div ">
              <Button type="submit" disabled={isSaveDisabled}>Save</Button>
            </div>

          </div>
          <DevTool control={control} />
        </form>
      </ReactModal>

      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default MDPublishedAddress;
